export default __webpack_public_path__ + "static/media/teacherStart.f3b883cf.svg";